import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { css } from "styled-components";

sortSelectStyles.select = {
    cssOverrides: {
        formField: css`
            > label {
                width: auto;
            }
            justify-content: center;
        `,
        formInputWrapper: css`
            width: auto;
            > select {
                width: calc(100% + 18px) !important;
            }
            > span {
                right: -18px !important;
            }
        `,
    },
};
